export enum RoleName {
  ASSET_ADMIN = "Asset Admin",
  TOOL_ADMIN = "Tool Admin",
  ASSET_MASTER = "Asset Master",
  TOOL_MASTER = "Tool Master",
  ASSET_USER = "Asset User",
  TOOL_USER = "Tool User",
}

export enum UserType {
  ADMIN = "admin",
  MASTER = "master",
  USER = "user",
}

export const ROLE_TO_USER_TYPE: Record<string, UserType> = {
  [RoleName.ASSET_ADMIN]: UserType.ADMIN,
  [RoleName.TOOL_ADMIN]: UserType.ADMIN,
  [RoleName.ASSET_MASTER]: UserType.MASTER,
  [RoleName.TOOL_MASTER]: UserType.MASTER,
  [RoleName.ASSET_USER]: UserType.USER,
  [RoleName.TOOL_USER]: UserType.USER,
};
